module.exports = __webpack_public_path__ + "img/e_3_4_r.842e01dc.png";